/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} New_Project_Youtube_Url_LabelInputs */



/**
* | output |
* | --- |
* | "YouTube Page URL" |
*
* @param {New_Project_Youtube_Url_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const new_project_youtube_url_label = /** @type {((inputs?: New_Project_Youtube_Url_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<New_Project_Youtube_Url_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("URL de la page YouTube")
	if (locale === "de") return /** @type {LocalizedString} */ ("YouTube-Seiten-URL")
	if (locale === "it") return /** @type {LocalizedString} */ ("URL della pagina YouTube")
	if (locale === "ru") return /** @type {LocalizedString} */ ("URL страницы YouTube")
	if (locale === "es") return /** @type {LocalizedString} */ ("URL de la página de YouTube")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("YouTube 页面网址")
	if (locale === "ja") return /** @type {LocalizedString} */ ("YouTubeページのURL")
	if (locale === "hi") return /** @type {LocalizedString} */ ("YouTube पेज URL")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("URL da página do YouTube")
	return /** @type {LocalizedString} */ ("YouTube Page URL")
});